import '../../stylesheets/src/sass/styles.scss'

/* 29585 - PWS mobile menu update - Start */
function toggleClasses(element, classesToRemove, classesToAdd = 'hide none') {
    element.removeClass(classesToRemove).addClass(classesToAdd);
}

function currentDivShow(getDataId) {
    const currentElementById = $(`#${getDataId}`)
    currentElementById.removeClass('none');

    const childElement = $('.child')
    if (!childElement.hasClass('hide') && !childElement.hasClass('none')) {
        childElement.addClass('hide none');
    }

    toggleClasses(currentElementById, 'hide none', 'active');
}

// Menu navigation code.
$('.parent .more').click(function () {
    var getDataId = $(this).attr('data-id');
    $('.menu-header').addClass('active');

    toggleClasses($('#parents-container'), 'active', 'hide')
    currentDivShow(getDataId);
});

$('.child .more').click(function () {
    var getDataId = $(this).attr('data-id');
    toggleClasses($('.children-1'), 'active')
    currentDivShow(getDataId);
});

$('.child .more-2').click(function () {
    var getDataId = $(this).attr('data-id');
    toggleClasses($('.children-2'), 'active')
    currentDivShow(getDataId);
});

$('.prev-parents-menu .more').click(function () {
    var getDataId = $(this).attr('data-id');
    toggleClasses($('.children-2, .children-3'), 'active')
    currentDivShow(getDataId);
});

$('.prev-parents-menu .more-2').click(function () {
    var getDataId = $(this).attr('data-id');
    toggleClasses($('.children-3'), 'active')
    currentDivShow(getDataId);
});

$('.menu-header .title').click(function () {
    const parentElement = $(this).parent()

    if (parentElement.hasClass('active')) {
        parentElement.removeClass('active');
        toggleClasses($('.child'), 'active', 'hide')
        $('.child').addClass('none');
        toggleClasses($('#parents-container'), 'hide', 'active')
    }
});

/* 29585 - PWS mobile menu update - End */

// This script seems to be inlined and used across the following template:
// BatteryConnectionRequest.cshtml, AccountVerificationForm.cshtml, HelpAndAdvice.cshtml, GeneralEnquiryForm.cshtml
// and NewConnectionBusiness.cshtml

function fileOnclick(index) {
    document.getElementById("file0").value = "";
    var input = $('#file0');
    input.trigger('input'); // Use for Chrome/Firefox/Edge
    input.trigger('change'); // Use for Chrome/Firefox/Edge + IE11/
}

// This function was an inline <script> block for the HelpAndAdvice.cshtml template.
function selectTopic_OnChange() {
    var index = $("#selectTopic")[0].selectedIndex;

    var fileAdder = $("#addFile_" + index);
    var cloneable = $("#fileCloneable_" + index);
    var appendable = $("#fileAttachments_" + index);
    var findRegex = /fileIgnore/g, replaceString = "file";

    var fileSlots = [1, 0, 0];

    var availableIndex = function () { return $.inArray(0, fileSlots); }

    // remove input
    function removeInput(e) {
        e.preventDefault();

        var index = parseInt($(e.target).attr("id").match(/\d+/g)); // get file slot index of deleted element;
        fileSlots[index] = 0;
        $(this).parent().remove();
        fileAdder.toggle(availableIndex() !== -1);
    }

    $("#file0Delete").click(removeInput); // attach to delete button

    fileAdder.click(function (e) {
        e.preventDefault();
        var index = availableIndex();
        fileSlots[index] = 1;

        // Clone file input and replace name to match up to cmd value
        var clone = $.parseHTML(cloneable.clone().toggle().attr("id", "file" + index).prop('outerHTML').replace(findRegex, replaceString + index));
        appendable.append(clone);

        $("#file" + index + "Delete").click(removeInput); // attach to delete button

        fileAdder.toggle(availableIndex() !== -1);
    });

    $('#ConfirmEmailAddress').bind("cut copy paste",
        function (e) {
            e.preventDefault();
        });
}

function generalEnquiry_formTypeLabel_OnChange() {
    document.getElementById("formTypeLabel").value =
        $("#generalEnquiry-formTypeLabel option:selected").text();
}

/**
 * Defect
 *
 * This can be reused by;
 * 1) add a file attachments container (#fileAttachments) to your form.
 * 2) add a file adder link/button (#addFile) to your form.
 * 3) Add file0, file1, ... to your command for posting optional extra files.
 * 4) add a renderErrors tag for file0
 *
 * Not perfect but can be made to work reusably until IE8 and 9 are dropped.
 *
 */
(function () {
    var fileAdder = $("#addFile"),
        cloneable = $("#fileCloneable"),
        appendable = $("#fileAttachments"),
        findRegex = /fileIgnore/g, replaceString = "file";

    var fileSlots = [1, 0, 0, 0, 0]; // This dictates how many files you can upload

    var availableIndex = function () {
        return $.inArray(0, fileSlots);
    }

    // remove input
    function removeInput(e) {
        e.preventDefault();

        var index = parseInt($(e.target).attr("id").match(/\d+/g)); // get file slot index of deleted element;
        fileSlots[index] = 0;
        $(this).parent().remove();
        fileAdder.toggle(availableIndex() !== -1);
    }

    $("#file0Delete").click(removeInput); // attach to delete button

    fileAdder.click(function (e) {
        e.preventDefault();
        var index = availableIndex();
        fileSlots[index] = 1;

        // Clone file input and replace name to match up to cmd value
        var clone = $.parseHTML(cloneable.clone().toggle().attr("id", "file" + index).prop('outerHTML').replace(findRegex, replaceString + index));
        appendable.append(clone);

        $("#file" + index + "Delete").click(removeInput); // attach to delete button

        fileAdder.toggle(availableIndex() !== -1);
    });

    $('#ConfirmEmailAddress').bind("cut copy paste", function (e) {
        e.preventDefault();
    });
})();

$('form div.experience-form-tooltip button.form-tooltip-toggle').click(function (e) {
    const $fieldGroup = $(e.target).parents('.field-group');
    if ($fieldGroup.length) {
        const toggleClass = $fieldGroup.attr('toggle-class');
        if (toggleClass) {
            $fieldGroup.toggleClass(toggleClass);
        }
    }
})

document.addEventListener("mouseup", function(event) {
    const userUtilityMenu = document.querySelector('.user-utilities-container');
    // only process the logic if the menu exist on the page and it's currently open.
    if (userUtilityMenu) {
        if (!userUtilityMenu.contains(event.target) && userUtilityMenu.classList.contains('user-utilities-container--active')) {
            document.body.classList.remove('user-utilities--active')
            userUtilityMenu.classList.remove('user-utilities-container--active')
        }
    }
});

// These are needed as a lot of templates in their pass were using global functions randomly across multiple templates.
window.toggleClasses = toggleClasses;
window.currentDivShow = currentDivShow;
window.fileOnclick = fileOnclick;
window.selectTopic_OnChange = selectTopic_OnChange;
window.generalEnquiry_formTypeLabel_OnChange = generalEnquiry_formTypeLabel_OnChange;